import Client from './Clients/AxiosClient'
const resource = 'accounts/settings'

export default {
  getInternalReviewSettings (id) {
    return Client.get(`${resource}/internal_review/${id}`)
      .then(response => response.data)
  },
  updateInternalReviewSetting (payload) {
    return Client.post(`${resource}/internal_review/bulk_update`, payload)
      .then(response => response.data)
  },
  updateInternalReviewOptOutSetting (payload) {
    return Client.post(`${resource}/opt_out_internal_review/bulk_update`, payload)
      .then(response => response.data)
  },
  updateAdviserNotesOptInSetting (payload) {
    return Client.post(`${resource}/opt_in_adviser_review_notes/bulk_update`, payload)
      .then(response => response.data)
  }
}
